/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { setCookie, getCookie } from 'bv';
import Rating from './rating';
import Padlock from './padlock';

export const RatingOrPadlock = (props) => {
  const { rating } = props;

  return (
    rating
      ? <Rating {...props} />
      : <Padlock {...props} />
  );
};

RatingOrPadlock.propTypes = {
  rating: PropTypes.number,
};

RatingOrPadlock.defaultProps = {
  rating: undefined,
};

class SmartAppBanner extends React.PureComponent {
  constructor(props) {
    super(props);

    this.closeBanner = this.hideBanner('closed', props.days_hidden || 15); // 0 to become 15
    this.installBanner = this.hideBanner('installed', props.days_reminder);
  }

  bannerUrl() {
    const { url } = this.props;

    const currentUrlParams = new URLSearchParams(window.location.search);
    const bannerUrl = new URL(url);

    const requiredCookies = ['btag', 'btagid', 'affid'];
    const rafCookie = getCookie('raf');

    // append current URL params to smart banner URL
    currentUrlParams.forEach((value, key) => {
      bannerUrl.searchParams.append(key, value);

      // set required cookies for 24 hours
      if (requiredCookies.includes(key)) {
        setCookie(key, value, '/', 86400000);
      }
    });

    if (!bannerUrl.pathname.toLowerCase().includes('&raf=') && (rafCookie !== undefined)) {
      bannerUrl.searchParams.append('raf', rafCookie);
    }

    return bannerUrl.toString();
  }

  hideBanner(reason, days) {
    if (!days) return null;

    const { setShowBanner } = this.props;

    return () => {
      setCookie(`smartbanner-${reason}`, true, '/', days * 86400000);
      setShowBanner(false);
    };
  }

  render() {
    const {
      device_class: deviceClass,
      icon_url: iconUrl,
      title,
      show_rating: showRating,
      button_text: buttonText,
    } = this.props;

    return (
      <div className={`smartbanner ${deviceClass}`}>
        <div className="smartbanner-container">
          <div className="left">
            <a className="smartbanner-close" onClick={this.closeBanner}>×</a>
            <span
              className="smartbanner-icon"
              style={{ 'background-image': `url(${iconUrl})` }}
            />
          </div>
          <div className="smartbanner-info">
            <div className="smartbanner-title">{title}</div>
            <div className="smartbanner-rating-button">
              {
                showRating
                && <RatingOrPadlock {...this.props} />
              }
              <a className="smartbanner-button" href={this.bannerUrl()} onClick={this.installBanner}>
                <span className="smartbanner-button-text">{buttonText}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SmartAppBanner.propTypes = {
  device_class: PropTypes.string.isRequired,
  icon_url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  button_text: PropTypes.string.isRequired,
  show_rating: PropTypes.bool.isRequired,
  days_hidden: PropTypes.number,
  days_reminder: PropTypes.number,
  setShowBanner: PropTypes.func.isRequired,
};

SmartAppBanner.defaultProps = {
  days_hidden: 15,
  days_reminder: 0,
};

export default SmartAppBanner;
